module.exports = __webpack_public_path__ + "static/male03-a2efcc89b4a341752fee26b9e1c3c311.png";